<template>
  <div class="sun" :style="styles">
    <div class="wrap">
      <img src="/static/images/svolt/nanwang/sun.png" />
    </div>
    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    styles: {
      type: Object
    },
    dir: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      len: '100px'
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
.sun {
  display: inline-block;
  position: absolute;
  .wrap{
    img{
      width: 59px;
      height: 59px;
      animation:sun1 3s infinite linear;
      position: relative;
    }
  }
}
@keyframes sun1 {
  from{
    transform: rotate(0deg);
  }

  to{
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/sun.vue